import { Component, Input, OnInit } from '@angular/core';

import { AuthService, User } from '@app/core';

@Component({
  selector: 'app-user-card',
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.scss'],
  standalone: false,
})
export class UserCardComponent implements OnInit {
  @Input() user: User;
  @Input() class!: string;
  @Input() isMe!: boolean;
  @Input() isRouterLinkDisabled!: boolean;
  loggedinUser: User;
  mailContent: string;

  constructor(private authService: AuthService) {
    this.loggedinUser = this.authService.user;
  }

  ngOnInit(): void {
    this.mailContent = 'mailto:' + encodeURIComponent(this.user.email);
  }
}
